export const appendixCommand = {
  previewAppendix: 'previewAppendix',
};
